<!-- 群详情 -->
<template>
  <div v-if="group.group_name">
    <el-page-header
      class="page-header"
      @back="goBack"
      :content="`${group.group_name}(${group.group_count})`"
    >
    </el-page-header>
    <div class="Mmain">
      <div class="header">
      <div class="table">
        <div class="table-content">
          <div class="content-t1">
            <div class="cell">
              <div class="label">群主:</div>
              <div class="value">
                {{ group.owner_name }}
              </div>
            </div>
          </div>
          <div class="content-t1">
            <div class="cell">
              <div class="label">创建时间:</div>
              <div class="value">
                {{ group.create_time }}
              </div>
            </div>
          </div>
          <div class="content-t3">
            <div class="cell">
              <div class="label">群公告:</div>
              <div class="value">
                {{ group.notice }}
              </div>
            </div>
          </div>
          <div class="content-t2">
            <div class="cell">
              <div class="label">群标签:</div>
              <div class="value">
                <span v-show="isEdit">
                  <el-select
                    v-model="label_group_id"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    collapse-tags	
                    placeholder="请搜索选择群标签"
                    size="small"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @focus="getTagList()"
                  >
                    <el-option
                      v-for="item in label_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </span>
                <span v-show="isEdit === false">
                  <el-tag
                    size="small"
                    style="margin-bottom: 1rem; margin-right: 1rem"
                    type="info"
                    v-for="item in group.label_group_name"
                    :key="item"
                    >{{ item }}</el-tag
                  >
                </span>
                <span class="edit-text" @click="onChangeState">
                  {{ !isEdit ? "编辑" : "确定" }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <el-table :data="group.data" border >
        <el-table-column prop="user_name" label="群成员名称"></el-table-column>
        <el-table-column prop="type_name" label="成员类型"></el-table-column>
        <el-table-column prop="status_name" label="状态"></el-table-column>
        <el-table-column
          prop="join_scene_name"
          label="进群方式"
        ></el-table-column>
        <el-table-column
          prop="join_time"
          label="进群时间"
        ></el-table-column>
      </el-table>
    </div>
  </div>
    
    
  </div>
</template>

<script>
export default {
  name: "clientBaseDetail",
  data() {
    return {
      group: {},
      isEdit: false,
      label_group_id: [],
      label_options: [],
      label_list: [],
      loading: false,
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.getTagList();
    this.getData();
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    async getTagList(q = "") {
      const { data: res } = await this.axios({
        url: "/crm/LabelGroup/getList2",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: q,
        }),
      });
      this.label_options = res.data.map((item) => {
        return { value: `${item.id}`, label: `${item.tag_name}` };
      });
    },
    async remoteMethod(query) {
      this.loading = true;
      const label_list = await this.getTagList(query);
      this.loading = false;
    },
    async getData() {
      const { data: res } = await this.axios({
        url: "/crm/Assistant/getClientBaseListOne",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          chat_id: this.$route.query.chat_id,
        }),
      });
      if (res.code == 1) {
        res.data.label_group_name = res.data.label_group_name.split(",");
        this.group = res.data;
        this.label_group_id = res.data.label_group_id;
      }
    },
    onChangeState() {
      if (this.isEdit) {
        this.editGroupLabel();
      }
      this.isEdit = !this.isEdit;
    },
    async editGroupLabel() {
      if(this.label_group_id.length==0){
        return
      }
      const { data: res } = await this.axios({
        url: "/crm/LabelGroup/editGroupLabel",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          chat_id: this.$route.query.chat_id,
          label_group_id: this.label_group_id,
        }),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      if (res.code == 1) {
        this.getData();
      }
      this.$message({
        type: res.code == 1 ? "success" : "error",
        message: res.msg,
      });
    },
  },
};
</script>
<style scoped>
.header {
  margin-bottom: 3rem;
}
.cell {
  display: flex;
  font-size: 1.4rem;
  color: #666666;
  margin-right: 3rem;
  align-items: baseline;
}
.label {
  padding-right: .6rem;
}
.content-t1 {
  display: flex;
  margin-bottom: 1.2rem;
}
.content-t2 {
  width: 100%;
  margin-top: 1.2rem;
  display: flex;
}
.edit-text {
  margin-left: .6rem;
  color: #49B372;
  cursor: pointer;
}
.content-t2 .cell{
  width: 100%;
}
.content-t2 .cell .value{
  height: 3.4rem;
}
.value span{
  display: inline-block;
}
</style>
<style>
.el-select__tags{
  max-width: auto!important;
}
.Mmain{
  background-color: #ffffff;
  border-radius: .8rem;
  padding: 3rem;
}
.page-header{
  margin-top: -.4rem;
  margin-bottom: 1.6rem;
}
</style>